import { render, staticRenderFns } from "./FormStage.vue?vue&type=template&id=6d3ae4c3"
import script from "./FormStage.vue?vue&type=script&lang=js"
export * from "./FormStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormStage.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d3ae4c3')) {
      api.createRecord('6d3ae4c3', component.options)
    } else {
      api.reload('6d3ae4c3', component.options)
    }
    module.hot.accept("./FormStage.vue?vue&type=template&id=6d3ae4c3", function () {
      api.rerender('6d3ae4c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/components/FormStage.vue"
export default component.exports